import { useEffect, useState } from "react";

export function useActiveId(itemIds) {
  const [activeId, setActiveId] = useState(``);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: `0% 0% 0% 0%` }
    );
    itemIds !== null &&
      itemIds.forEach((id) => {
        document.getElementById(id) !== null &&
          observer.observe(document.getElementById(id));
      });

    return () => {
      itemIds !== null &&
        itemIds.forEach((id) => {
          document.getElementById(id) !== null &&
            observer.unobserve(document.getElementById(id));
        });
    };
  }, [itemIds]);

  return activeId;
}
